module.exports = __webpack_public_path__ + "static/img/dualipa.aa0d764.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dualipa.jpg
// module id = l0gT
// module chunks = 31